<div edsPadding edsPaddingAll="lg">
  <div edsSpacing="lg">
    <eds-image
      imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
      imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
    >
    </eds-image>
  </div>
  <p>
    {{ "literature.lit-order-customer-service" | translate }}
  </p>
</div>
